import { LedgerEntry } from 'src/app/objects/ledger-entry';

export class Group {
    group_id: number;
    usga_club_id: number;
    group_type: number;
    group_name: string;
    player_id: number;
    nbr_of_ads: number;
    logo_url: string;
    rel_ads_url: string;
    expiration_date?: any;
    state: string = 'off';
    is_private: string;
    ledger: LedgerEntry[];
    total_credits: number;
    show_ledger: boolean;
    credits_awarded:number;
    credits_used: number;
}
    
    